import { render } from "./Alphabet.vue?vue&type=template&id=a1e0883e"
import script from "./Alphabet.vue?vue&type=script&lang=js"
export * from "./Alphabet.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Vue\\guesswhat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__